<template>
  <div>
    <b-row
      align-v="center"
    >
      <b-col class="p-0">
        <CheckBoxConfiguration
          :controller="ImpedanceFitGraphBool"
          :switchprop="true"
        />
      </b-col>
      <b-col
        v-if="ImpedanceFitGraphBool.value"
        class="m-0 p-0"
        cols="2"
      >
        <b-button
          size="sm"
          variant="outline-primary"
          class="m-0 p-0"
          @click="ImpedanceFitGraphExpanded=!ImpedanceFitGraphExpanded"
        >
          <b-icon
            v-if="ImpedanceFitGraphExpanded"
            aria-label="More"
            icon="caret-up"
          />
          <b-icon
            v-else
            aria-label="More"
            icon="caret-down"
          />
        </b-button>
      </b-col>
    </b-row>
    <b-row v-if="ImpedanceFitGraphBool.value">
      <b-collapse
        v-model="ImpedanceFitGraphExpanded"
        class="ml-5 mb-2 expanded-info p-1 w-100"
      >
        <CircuitConfiguration :sectionconfig="sectionconfig" />
        <FitSelection
          :sectionconfig="sectionconfig"
          :fitname="fitName"
        />
      </b-collapse>
    </b-row>
  </div>
</template>

<script>
import CircuitConfiguration from '../CircuitConfiguration'
import CheckBoxConfiguration from '../CheckBoxConfiguration'
import FitSelection from './model/FitSelection'
import {checkBoxGraphConfCtrller} from '@/assets/classes/configuration.js'
import { ConfigName } from '@/common/sharedDefinitions/commonPlotDefinitions'
import { mapGetters } from 'vuex'

const fitName = 'equivalentCircuit'
const rootContextFolder='ReportViewer/Fit/' + fitName
const zoneNotify='CircuitEquivalent'

export default {
  name: zoneNotify,
  components:{
    CircuitConfiguration,
    CheckBoxConfiguration,
    FitSelection
  },
  props: { 
    sectionconfig:{
      type:String,
      required: true
    },
  },
  data() {
    return {
      elementsConfig:[],
      fitName,
      ImpedanceFitGraphBool: new checkBoxGraphConfCtrller(`{0}.${ConfigName.ImpedanceFitDiscreteGraph}`,'Circuit Fit',false,rootContextFolder+'ImpedanceFit',true),
      ImpedanceFitGraphExpanded:true,
    }
  },
  computed: mapGetters([
    'getCurrentReportViewer',
  ]),
  watch:{
    sectionconfig(){
      this.configureStudy()
    }
  },
  mounted(){
    this.elementsConfig = [
      this.ImpedanceFitGraphBool
    ]
    this.configureStudy()
    this.$watch(
      'ImpedanceFitGraphBool.value',
      () => {
        this.verifyConfiguration()
      }
    );
  },
  methods:{
    configureStudy(){
      try{
        this.elementsConfig.forEach(conf=>conf.configCategory=this.sectionconfig)
        this.ImpedanceFitGraphBool.formatKeyValue(this.sectionconfig)
        this.ImpedanceFitGraphBool.setParent(this)
        this.verifyConfiguration()
        
      }catch(err){
        const errTitle='Error loading Multi Mean Fit'
        const errText=`Error loading Multi Mean Fit for ${this.sectionconfig}. Message: ${err}`
        this.$notifTerm.addNotification(this.$notifTerm.typesNotif.ERROR,errTitle,errText,zoneNotify)
      }
    },
    verifyConfiguration(){
      if(this.ImpedanceFitGraphBool.value){
        this.elementsConfig.forEach(conf=>conf.setParent(this))
      }else if(
        typeof(this.getCurrentReportViewer.configuration[this.sectionconfig]) !== 'undefined'
        &&typeof(this.getCurrentReportViewer.configuration[this.sectionconfig][ConfigName.BaseCurveFit])!=='undefined' 
        && typeof(this.getCurrentReportViewer.configuration[this.sectionconfig][ConfigName.BaseCurveFit][fitName])!=='undefined'
      ){
        delete this.getCurrentReportViewer.configuration[this.sectionconfig][ConfigName.BaseCurveFit][fitName]
      }
    },
  }
}
</script>

<style>
.expanded-info{
  background-color: #DDD;
  border-radius: 5px;
}
</style>